<template>
  <div class="flex items-center justify-center w-full h-full p-4">
    Loading...
  </div>
</template>
